export default "__VITE_ASSET__db485e31__"